<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <!-- <div class="float-right">
                    <button class="btn dash-btns mr-3" [routerLink]="['/pos/businesshour/manage']">Manage Business Hours</button>
                    <button class="btn dash-btns"  [routerLink]="['/pos/businesshour/new']">New Business Hours</button>

                </div> -->
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <a class="view-h gary-t"> View  Business Hours</a>
                                </div>
                                
                                <div class="pt-3">
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1"> Hours Type</div>
                                        
                                        <div class="col-7 view-text"> {{rows.HourType}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Week Day</div>
                                        
                                        <div class="col-7 view-text"> {{rows.WeekDay}}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Time From </div>
                                        
                                        <div class="col-7 view-text"> {{rows.TimeFrom}}</div>
                                    </div>
                                   
                                  
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1"> Time To </div>
                                        
                                        <div class="col-7 view-text"> {{ rows.TimeTo }}</div>
                                    </div>
                                  
                                    <div class="row mb-3">
                                        <div class="col-4 p-0 label1">Date Time</div>
                                        
                                        <div class="col-7 view-text"> {{rows.DateTime | date:'d/M/yy, h:mm a'}}</div>
                                    </div>
                                   
                                    <div class="text-right py-2">
                                        <button class="btn dash-btns mr-3" [routerLink]="['/pos/businesshour/manage']">Back</button>
                                        <!-- <button class="btn dash-btns"  [routerLink]="['/pos/businesshour/new']">New Business Hours</button> -->
                                    </div>                                                        
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="card p-2">
                        <div class="text-center">
                           <img src="https://fastswiff.com/assets/img/easytouse.png"   class="w-100" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
 